var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "projects-po-balance-cal-view" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "small-7 medium-7 large-7 columns" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "small-3 medium-3 large-3 columns align-right" },
        [
          _c("label", { staticClass: "amount uppercase" }, [
            _vm._v(_vm._s(_vm.$t("amount"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "small-2 medium-2 large-2 columns align-right" },
        [
          _c("label", { staticClass: "percentage uppercase" }, [
            _vm._v(_vm._s(_vm.$t("percentage"))),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row odd-row body-row" }, [
      _c("div", { staticClass: "small-7 medium-7 large-7 columns" }, [
        _c("label", { staticClass: "align-left row-title" }, [
          _vm._v(_vm._s(_vm.amountLabel)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "small-3 medium-3 large-3 columns align-right" },
        [
          _c("label", { staticClass: "amount" }, [
            _vm._v(
              _vm._s(
                _vm._f("formatCurrency")(_vm.purchaseAmount, {
                  currencyCode: _vm.currencyCode,
                })
              )
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
    ]),
    _vm._v(" "),
    _vm.deductionAmount > 0
      ? _c("div", { staticClass: "row body-row" }, [
          _c("div", { staticClass: "small-7 medium-7 large-7 columns" }, [
            _c("label", { staticClass: "align-left row-title" }, [
              _vm._v(_vm._s(_vm.$t("project.deduction.label"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "small-3 medium-3 large-3 columns align-right" },
            [
              _c("label", { staticClass: "amount" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatCurrency")(_vm.deductionAmount, {
                      currencyCode: _vm.currencyCode,
                    })
                  )
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._m(1),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row body-row" }, [
      _c("div", { staticClass: "small-7 medium-7 large-7 columns" }, [
        _c("label", { staticClass: "align-left row-title" }, [
          _vm._v(_vm._s(_vm.$t("project.submission.previousAmount"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "small-3 medium-3 large-3 columns align-right" },
        [
          _c("label", { staticClass: "amount" }, [
            _vm._v(
              _vm._s(
                _vm._f("formatCurrency")(_vm.previousTotalAmount, {
                  currencyCode: _vm.currencyCode,
                })
              )
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "small-2 medium-2 large-2 columns align-right" },
        [
          _c("label", { staticClass: "percentage" }, [
            _vm._v(_vm._s(_vm.previousAmountPct) + "%"),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row odd-row body-row" }, [
      _c("div", { staticClass: "small-7 medium-7 large-7 columns" }, [
        _c(
          "label",
          {
            staticClass: "align-left row-title",
            class: { "label-with-hint required-flag": !_vm.readonly },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("project.submission.currentAmount")) +
                "\n      "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.readonly
        ? _c(
            "div",
            { staticClass: "small-3 medium-3 large-3 columns align-right" },
            [
              _c("label", { staticClass: "amount" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatCurrency")(_vm.currentAmount, {
                      currencyCode: _vm.currencyCode,
                    })
                  )
                ),
              ]),
            ]
          )
        : _c(
            "div",
            { staticClass: "small-3 medium-3 large-3 columns align-right" },
            [
              _c("div", { staticClass: "no-margin-right" }, [
                _c("p", { staticClass: "amount-ccy" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.currencyCode || _vm.$globalProps.getCurrency()
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    { name: "hkldinput", rawName: "v-hkldinput" },
                    {
                      name: "fusioninputcheck",
                      rawName: "v-fusioninputcheck",
                      value: !_vm.showInvoiceModule && {
                        type: "decimal",
                        pattern: function (val) {
                          return (
                            (Number((val || "").replace(/,/g, "")) || 0) >= 0
                          )
                        },
                      },
                      expression:
                        "!showInvoiceModule && {\n            type: 'decimal',\n            pattern: (val) => (Number((val || '').replace(/,/g, '')) || 0) >= 0\n          }",
                    },
                  ],
                  staticClass: "amount-input",
                  class: {
                    "error-highlight":
                      !_vm.showInvoiceModule && _vm.highlightInvalid,
                  },
                  attrs: {
                    disabled: _vm.showInvoiceModule,
                    type: "text",
                    novalidate: "",
                  },
                  domProps: {
                    value:
                      _vm.submission.completedAmountText ||
                      _vm.submission.completedAmount,
                  },
                  on: {
                    change: function (event) {
                      _vm.updateField(
                        "completedAmountText",
                        event.target.value,
                        "string"
                      ),
                        _vm.updateField("completedAmount", event.target.value),
                        _vm.$emit("clear:errorHighlight")
                    },
                  },
                }),
              ]),
            ]
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "small-2 medium-2 large-2 columns align-right",
          class: { "completion-percentage": !_vm.readonly },
        },
        [
          _c("label", { staticClass: "percentage" }, [
            _vm._v(_vm._s(_vm.currentAmountPct) + "%"),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row body-row" }, [
      _c(
        "div",
        {
          staticClass: "small-7 medium-7 large-7 columns",
          class: { "label-with-hint-balance": !_vm.readonly },
        },
        [
          _c("label", { staticClass: "align-left row-title" }, [
            _vm._v(_vm._s(_vm.remainingBalanceLabel)),
          ]),
          _vm._v(" "),
          !_vm.readonly
            ? _c("p", { staticClass: "hint" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.remainingBalanceHint) + "\n      "
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "small-3 medium-3 large-3 columns",
          class: { "balance-percentage": !_vm.readonly },
        },
        [
          _c("label", { staticClass: "amount" }, [
            _vm._v(
              _vm._s(
                _vm._f("formatCurrency")(_vm.remainingBalance, {
                  currencyCode: _vm.currencyCode,
                })
              )
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "small-2 medium-2 large-2 columns align-right",
          class: { "balance-percentage": !_vm.readonly },
        },
        [
          _c("label", { staticClass: "percentage" }, [
            _vm._v(_vm._s(_vm.remainingBalancePct) + "%"),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "small-2 medium-2 large-2 columns align-right" },
      [_c("label", { staticClass: "percentage" }, [_vm._v("--")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "small-2 medium-2 large-2 columns align-right" },
      [_c("label", { staticClass: "percentage" }, [_vm._v("--")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }